import { DesignSystem } from "../design-system.js";
import { Wizard } from "./wizard.js";
import { styles } from "./wizard.styles.js";
import { template } from "./wizard.template.js";
/**
 *
 * @public
 * @remarks
 * HTML Element: <fabric-wizard>
 */
export const definition = Wizard.compose({
    name: `${DesignSystem.prefix}-wizard`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=wizard.definition.js.map